import React from 'react';
import { Link } from 'react-router-dom';
import 'iconify-icon';
import { PRODUCTS_META } from './franchise-shared';

export const FranchiseProducts = ({ productsOffered }) => {
  if (!productsOffered?.length) return null;
  return (
    <section
      className="relative py-12 border-b border-neutral-900"
      style={{ background: 'rgba(17, 17, 17, 0.85)' }}
      data-testid="franchise-products-section"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-accent-orange mb-3 block">
          Programas oferecidos
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[#EAEAEA] mb-6">
          {productsOffered.length} programa{productsOffered.length > 1 ? 's' : ''} disponível
          {productsOffered.length > 1 ? 'eis' : ''} nesta unidade
        </h2>
        <div className="flex flex-wrap gap-3">
          {productsOffered.map((slug) => {
            const meta = PRODUCTS_META[slug];
            if (!meta) return null;
            return (
              <Link
                key={slug}
                to={`/${slug}`}
                data-testid={`franchise-product-${slug}`}
                className="inline-flex items-center gap-2 px-5 py-3 bg-[#0F0F0F] border border-[#333333] rounded-xl text-sm font-bold text-[#EAEAEA] hover:border-accent-orange hover:text-accent-orange transition-colors"
              >
                <iconify-icon icon={meta.icon} className="text-accent-orange text-lg"></iconify-icon>
                {meta.name}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
